// account
export const SET_ACCOUNT = "setAccount";
export const SET_SESSION_TOKEN = "setToken";

// users
export const SET_USER = "setUser";
export const SET_USERS = "setUsers";

// verifications
export const SET_VERIFICATION = "setVerification";
export const SET_VERIFICATIONS = "setVerifications";

// bank (recipient) accounts
export const SET_BANK_ACCOUNT = "setBankAccount";
export const SET_BANK_ACCOUNTS = "setBankAccounts";

// subscription + plans
export const SET_SUBSCRIPTION = "setSubscription";
export const SET_SUBSCRIPTIONS = "setSubscriptions";
export const SET_SUBSCRIPTION_PLANS = "setSubscriptionPlans";

// router_loader
export const SET_ROUTER_LOADER = "setRouterLoader";

// error
export const SET_ERRORMSG = "setErrorMsg";
